// extracted by mini-css-extract-plugin
export default {"manage-view-text":"manage-view-text_IEpGwDwS"};